import { endOfDay } from 'date-fns';

import { sdpNumber } from '../../common/pipe/single-decimal-point';
import { TrendAxisDataAxisPathPointInsight } from '../../scorecard-mi2/trend-dialog/model/trend-axis-data-axis-path-point-insight.model ';
import { TrendData } from '../models/my-coaching-card-group.model';

/**
 * Generates target points for the trend chart.
 * @param trendData - The sorted trend data array
 * @param color - The color to assign to the points.
 * @returns Transformed array of target points.
 */
export function createTargetPoints(
    trendData: TrendData[],
    color: string = '#000',
): TrendAxisDataAxisPathPointInsight[] {
    return (
        trendData
            ?.filter((trendItem) => trendItem.target != null)
            .map((trendItem) => {
                const pd = (trendItem.periodDate as any as string)
                    ?.trim()
                    ?.toLowerCase();
                return {
                    x: endOfDay(
                        pd?.endsWith('z')
                            ? new Date(pd.slice(0, -1))
                            : new Date(pd),
                    ),
                    y: trendItem.target * 10,
                    color,
                    target: sdpNumber(trendItem.target * 100),
                };
            }) ?? []
    );
}
